
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M111.5 21.1c-8.1-9-18.8-15.6-30.5-18.8C73.4.2 65.4-.4 57.5.4 44.3 1.6 31.6 7.1 21.7 15.9 13.4 23.2 7.1 32.7 3.4 43.2-.8 55.5-1.2 69 2.4 81.5c3 10.8 9 20.8 17.1 28.6 8.1 7.9 18.4 13.6 29.4 16.2 15.3 3.8 32 1.7 45.9-6 11.1-6.1 20.4-15.5 26.1-26.7 6.8-13 8.8-28.3 5.8-42.7-2.4-11.2-7.7-21.5-15.2-29.8zm-46.2 89.2c-6.3 2.4-13.6 2.9-19.8-.2-4.7-2.3-7.9-6.9-9.1-11.8-1.8-7.1-.6-14.6 1.8-21.4 1.1-3.1 2.5-6 4-8.9-5.4 5.4-10.7 10.9-16 16.4C34.1 73.6 42.6 63.1 52 53.5c5-4.8 10-9.5 15.2-14 1.8-1.6 3.6-3.1 5.6-4.4-3.6 4.6-6.6 9.5-9.3 14.6-3.4 6.4-6.5 13.1-8.5 20.1-2 7.1-3.2 14.9-.5 22 1.6 3.8 4.4 7.7 8.7 8.7 7.7 1.9 16.1-.1 22.3-4.9-5.5 6.2-12.3 11.6-20.2 14.7zm21.2-75.1c-1.6-.8-3.1-1.5-4.7-2.3-1.5.9-3.1 1.7-4.6 2.5.3-1.7.5-3.4.8-5.2l-3.9-3.6c1.7-.3 3.4-.6 5.2-.9.7-1.6 1.5-3.2 2.2-4.8.8 1.5 1.6 3.1 2.4 4.7 1.7.2 3.5.5 5.3.7-1.3 1.2-2.4 2.5-3.7 3.8.4 1.6.7 3.3 1 5.1z"}})])
          )
        }
      }
    